import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import DataTable from "examples/Tables/DataTable";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { Card, Grid, Tooltip, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import { Link } from "react-router-dom";

export default class AmenitiesList extends Component {
  state = {
    amenities: [],
    per_page: 20,
    page: 1,
    pagination: {
      total: 0,
      totalpage: 1,
      page: 1,
      limit: 20,
      nextpage: false,
      prevpage: false,
    },
    loading: false,
    notification: false,
    notiColor: "success",
    message: "",
  };

  componentDidMount() {
    this.fetch(this.state.page, this.state.per_page);
  }

  fetch = (page = 1, limit = 20) => {
    if (init() !== "success") return;

    this.setState({ loading: true });

    axios
      .get(`${Constants.getUrls.getAllAmenities}?page=${page}&limit=${limit}`)
      .then((resp) => {
        if (resp.data?.status === "success") {
          const rows = resp.data.data || [];
          const p = resp.data.pagination || {};

          this.setState({
            amenities: rows,
            pagination: {
              total: p.total || 0,
              totalpage: p.totalpage || 1,
              page: p.page || page,
              limit: p.limit || limit,
              nextpage: !!p.nextpage,
              prevpage: !!p.prevpage,
            },
            page: p.page || page,
            loading: false,
          });
        } else {
          this.setState({
            notification: true,
            notiColor: "warning",
            message: resp.data?.message || "Failed to fetch amenities",
            loading: false,
          });
        }
      })
      .catch(() =>
        this.setState({
          notification: true,
          notiColor: "warning",
          message: "Something went wrong!",
          loading: false,
        })
      );
  };

  onEntriesChange = (limit) => {
    this.setState({ per_page: limit }, () => this.fetch(1, limit));
  };

  onPageChange = (newPage) => {
    this.fetch(newPage, this.state.per_page);
  };

  handleDelete = (id) => {
    if (!window.confirm("Are you sure you want to delete this Amenity?")) return;

    axios
      .delete(Constants.deleteUrls.deleteAmenity + id)
      .then((resp) => {
        this.setState(
          {
            notification: true,
            notiColor: "success",
            message: resp.data?.message || "Deleted Successfully!",
          },
          () => this.fetch(this.state.pagination.page, this.state.per_page)
        );

        setTimeout(() => this.setState({ notification: false, message: "" }), 2000);
      })
      .catch((err) =>
        this.setState({
          notification: true,
          notiColor: "warning",
          message: err?.response?.data?.message || "Delete failed",
        })
      );
  };

  render() {
    const { amenities, pagination, loading } = this.state;

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>
            {/* Header */}
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Amenities List
              </MDTypography>
            </MDBox>

            {/* Add Button */}
            <Grid item sm={4} px={2} align="right">
              <Link to="/addAmenity">
                <MDButton variant="contained" size="small" color="primary">
                  Create New
                </MDButton>
              </Link>
            </Grid>

            {/* Table */}
            <MDBox py={3}>
              {loading ? (
                <Grid align="center">
                  <h4>Loading...</h4>
                </Grid>
              ) : amenities.length > 0 ? (
                <DataTable
                  table={{
                    columns: [
                      { Header: "S.No", accessor: "serial", width: "6%" },
                      { Header: "Icon", accessor: "icon" },
                      { Header: "Title", accessor: "title" },
                      { Header: "Text", accessor: "text" },
                      { Header: "Actions", accessor: "action" },
                    ],
                    rows: amenities.map((item, i) => ({
                      serial: (pagination.page - 1) * pagination.limit + (i + 1),
                      icon: item.icon ? (
                        <img
                          src={Constants.imageDomain + item.icon}
                          alt="icon"
                          style={{
                            height: 50,
                            width: 50,
                            objectFit: "contain",
                            borderRadius: 6,
                          }}
                        />
                      ) : (
                        "No Icon"
                      ),
                      title: item.title || "—",
                      text: item.text || "—",

                      action: (
                        <div style={{ display: "flex", gap: 10 }}>
                          <Tooltip title="Edit Amenity">
                            <Link to={`/updateAmenity/${item._id}`}>
                              <IconButton color="info" size="small">
                                <EditIcon fontSize="small" />
                              </IconButton>
                            </Link>
                          </Tooltip>

                          <Tooltip title="Delete Amenity">
                            <IconButton
                              color="error"
                              size="small"
                              onClick={() => this.handleDelete(item._id)}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </div>
                      ),
                    })),
                  }}
                  entriesPerPage={{ defaultValue: this.state.per_page }}
                  page_no={pagination.page}
                  totalPages={pagination.totalpage}
                  totalDocs={pagination.total}
                  onPageChange={this.onPageChange}
                  onEntriesPerPageChange={this.onEntriesChange}
                />
              ) : (
                <div style={{ padding: 20 }}>No Amenities Found</div>
              )}
            </MDBox>

            <MDSnackbar
              color={this.state.notiColor}
              icon="notifications"
              title="Amenities Admin"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
